import { Reveal } from "@/components/site/motion";
import { BrainCircuit, Route, ClipboardCheck, ScanSearch, FolderLock, CalendarClock, Activity, Languages, Headset } from "lucide-react";

const BENEFITS = [
  { icon: BrainCircuit, title: "AI-Powered Student Matching", body: "Surface applicants who genuinely fit your courses and entry requirements." },
  { icon: Route, title: "One Streamlined Journey", body: "A single, consistent admissions process from first enquiry to enrolment." },
  { icon: ClipboardCheck, title: "Reduced Administrative Workload", body: "Automate repetitive tasks so your teams focus on decisions, not data entry." },
  { icon: ScanSearch, title: "Automated Eligibility Screening", body: "Applicants are pre-checked against your criteria before they reach your team." },
  { icon: FolderLock, title: "Secure Document Management", body: "Documents uploaded once, stored securely, and shared only with consent." },
  { icon: CalendarClock, title: "Interview Scheduling Automation", body: "Coordinate interviews automatically around applicant and staff availability." },
  { icon: Activity, title: "Applicant Progress Tracking", body: "Follow every applicant through each stage of the pipeline in real time." },
  { icon: Languages, title: "Multilingual Applicant Support", body: "Engage international applicants in the language they're most comfortable with." },
  { icon: Headset, title: "Human Support When Required", body: "Dedicated support for applicants and providers whenever it's needed." },
];

export const WhyPartner = () => (
  <section id="why-partner" data-testid="why-partner-section" className="relative bg-surface py-28 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">Why Partner With Us</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display font-extrabold tracking-tighter text-ink text-4xl sm:text-5xl leading-[0.98]">
            A recruitment platform built on technology.
          </h2>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {BENEFITS.map((b, i) => (
          <Reveal key={i} delay={(i % 3) * 0.06} className="group rounded-3xl border border-slate-200 bg-white p-7 transition-transform duration-300 hover:-translate-y-1 hover:border-cobalt/30" data-testid={`benefit-card-${i}`}>
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-cobalt/10">
              <b.icon className="h-6 w-6 text-cobalt" strokeWidth={1.75} />
            </div>
            <h3 className="mt-5 font-display text-lg font-bold tracking-tight text-ink leading-tight">{b.title}</h3>
            <p className="mt-2.5 text-sm leading-relaxed text-slatey">{b.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
